import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPatch from "../axios/axios-patch";
import axiosPost from "../axios/axios-post";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

export const AuthAPI = Object.freeze({
  login: createAsyncThunk("post/login", async (data) => {
    try {
      const response = await axiosPost.post("/login", data);
      return response.data;
    } catch (error) {
      return Promise.reject(error || "An error occurred");
    }
  }),

  logout: createAsyncThunk("post/logout", async () => {
    try {
      const response = await axiosPost.post("/logout");
      return response;
    } catch (error) {
      return Promise.reject(error || "An error occurred");
    }
  }),

  deleteUser: createAsyncThunk("delete/user", async (id) => {
    try {
      const response = await axiosDelete.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error || "An error occurred");
    }
  }),

  blockUser: createAsyncThunk(
    "patch/block-user",
    async ({ user_id, blocked }) => {
      try {
        const response = await axiosPatch.patch(`/users/${user_id}`, {
          blocked,
        });
        return response.data;
      } catch (error) {
        return Promise.reject(error || "An error occurred");
      }
    }
  ),

  changeRole: createAsyncThunk("patch/change-role", async (data) => {
    try {
      const response = await axiosPatch.patch(`/users/${data.id}`, data);
      return response.data;
    } catch (error) {
      return Promise.reject(error || "An error occurred");
    }
  }),

  getUsersList: createAsyncThunk("get/admin-list", async (params) => {
    try {
      const response = await axiosGet.get(`/users`, { params });
      return response.data;
    } catch (error) {
      return Promise.reject(error || "An error occurred");
    }
  }),
});
